var chunkToChildrenMap = {
	"1189": [
		1218
	],
	"1218": [
		1218
	],
	"1911": [
		1218
	],
	"1913": [
		1189
	],
	"4882": [
		1218,
		1189
	],
	"5123": [
		1218,
		1189
	],
	"7339": [
		1218,
		1189
	],
	"7366": [
		1218,
		1189
	],
	"7996": [
		1218,
		1189
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };